import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

export const Modal: React.FC<{
  title: string;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  wide?: boolean;
}> = ({ title, open, onClose, children, footer, wide }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={wide ? { maxWidth: 940 } : undefined} role="dialog" aria-modal="true">
        <header className="modal-head">
          <h2>{title}</h2>
          <button className="modal-x" onClick={onClose} aria-label="Schließen">×</button>
        </header>
        <div className="modal-body">{children}</div>
        {footer ? <footer className="modal-foot">{footer}</footer> : null}
      </div>
    </div>,
    document.body
  );
};

/** Formularzeile mit Label — hält die Anlegen-Masken kompakt und einheitlich. */
export const F: React.FC<{
  label: string;
  children: React.ReactNode;
  hint?: string;
  span?: number;
}> = ({ label, children, hint, span = 1 }) => (
  <div className="field" style={{ gridColumn: `span ${span}` }}>
    <label>{label}</label>
    {children}
    {hint ? <div className="small muted" style={{ marginTop: 3 }}>{hint}</div> : null}
  </div>
);

export const FormGrid: React.FC<{ children: React.ReactNode; cols?: number }> = ({ children, cols = 3 }) => (
  <div className="form-grid" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0,1fr))` }}>
    {children}
  </div>
);
